<template>
  <div class="address-comparison" v-loading="loading">
    <div class="user_search">
      <span style="width: 100px;display: inline-block">{{ $t('title.RPC_service') }}：</span>
      <el-select style="width: 220px" v-model="selectValue" @change="changeRpc()" :placeholder="this.$t('title.RPC_service')">
        <el-option v-for="item in options" :key="item.rpcUrl" :label="item.name" :value="item.rpcUrl"></el-option>
      </el-select>
      <el-select style="margin-left: 5%;width: 220px" v-model="selectChain" @change="changeChain()" :placeholder="$t('title.Please_select_the_chain')">
        <el-option v-for="item in options1" :key="item" :label="item+$t('title.chain')" :value="item"></el-option>
      </el-select>
    </div>
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
      <el-form-item prop="address1">
        <el-input v-model="ruleForm.address1" :placeholder="$t('title.enter_address_compared')"></el-input>
      </el-form-item>
      <el-form-item prop="address2">
        <el-input v-model="ruleForm.address2" :placeholder="$t('title.enter_address_compared')"></el-input>
      </el-form-item>
      <el-button type="primary" @click="comparison">{{$t('title.Compare_addresses')}}</el-button>
      <el-form-item v-if="result" class="result">
        {{result}}
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import {
	getrpcserver,
	getchaininfo,
} from "../../../api/interface";
import request from '@/utils/request'
export default {
  name: "AddressComparison",
  components: { },
  data() {
    return {
      ruleForm: {
        address1: '',
        address2: '',
      },
      rules: {
        address1: [
          { required: true, message: this.$t('title.enter_address_compared'), trigger: 'change' }
        ],
        address2: [
          { required: true, message: this.$t('title.enter_address_compared'), trigger: 'change' }
        ],
      },
      loading: false,
      selectValue: "",
      options: "",
      selectChain: "",
      options1: "",
      browserUrl: '',
      result: ''
    };
  },
  methods: {
    comparison() {
      this.result = ''
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (this.ruleForm.address1.length < 42 && this.ruleForm.address2.length < 42) {
            this.$message.error("Please enter the correct address!");
            return false;
          }
          this.loading = true
          let address1 = this.ruleForm.address1.toLowerCase()
          let address2 = this.ruleForm.address2.toLowerCase()
          request({
              url: `${this.browserUrl}/v1/checkDeployedCode/${address1}/${address2}`,
              method: 'get',
          }).then((res) => {
            console.log(res)
            if (res.code == '200') {
              this.result = String(res.data.result)
            } else {
              this.result = ''
              this.$message.error(res.msg);
            }
            this.loading = false
          }).catch((err) => {
            this.result = ''
            this.$message.error(err.msg);
            this.loading = false
          })
        } else {
          return false;
        }
      });
    },
    changeChain() {},
    changeRpc() {
      let data = { rpcServer: this.selectValue };
      getchaininfo(data).then(response => {
        this.options1 = response.data;
        this.selectChain = this.options1[0];
      });
    },
    getData() {
      getrpcserver().then(response => {
        console.log(response.data)
        this.options = response.data;
        this.selectValue = this.options[0].rpcUrl;
        this.browserUrl = this.options[0].browserUrl
        let data = { rpcServer: this.options[0].rpcUrl };
        getchaininfo(data).then(response => {
          this.options1 = response.data;
          this.selectChain = this.options1[0];
        });
      });
    },
  },
  computed: {
  },
  created() {
    this.getData()
  }
};
</script>
<style scoped >
  .address-comparison {
    padding: 20px 30px;
    height: 100%;
  }
  .user_search {
    margin-bottom: 40px;
  }
  .el-form-item {
    width: 70%;
    margin-bottom: 40px;
  }
  .result {
    margin-top: 80px;
  }
  .result /deep/.el-form-item__content {
    font-size: 20px;
    color: red;
  }
</style>
